/**
 * http://github.serafin.io/vuebar/
 * example: http://jsfiddle.net/u94ns8jc/1/?utm_source=website&utm_medium=embed&utm_campaign=u94ns8jc
 */

import Vue from './../../vue';
import Vuebar from 'vuebar';

Vue.use(Vuebar);
